import React, { Component } from 'react'
import Popover from 'components/Popover'
import { uniqueId } from 'lodash'
import IconChevronDown from 'components/Icons/ChevronDown'
import Calendar from './Calendar'
import InputMessage from '../InputMessage'

import cn from 'classnames'
import s from './DatePicker.scss'
import sInput from '../Input/Input.scss'

export default class DatePicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      inputId: uniqueId('input'),
      viewDate: new Date(),
    }
  }
  onPickDate = date => {
    const {
      input: { onChange },
    } = this.props
    onChange(date)
    this.onBlur()
  }
  onNextMonth = () => {
    const { viewDate } = this.state
    this.setState({ viewDate: new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 1) })
    this.onFocus()
  }
  onPrevMonth = () => {
    const { viewDate } = this.state
    this.setState({ viewDate: new Date(viewDate.getFullYear(), viewDate.getMonth() - 1, 1) })
    this.onFocus()
  }
  onChange = event => {
    const {
      input: { onChange },
    } = this.props
    onChange(event.target.value)
    const [date, month, year] = event.target.value.split('/')
    const value = date && month && year ? new Date(year, month - 1, date) : ''
    if (value) {
      this.setState({ viewDate: value })
    }
  }
  onBlurTimeout = undefined
  onBlur = () => {
    const { input } = this.props
    clearTimeout(this.onBlurTimeout)
    this.onBlurTimeout = setTimeout(input.onBlur, 100)
  }
  onFocus = () => {
    const { input } = this.props
    clearTimeout(this.onBlurTimeout)
    input.onFocus()
  }
  render() {
    const {
      input,
      display,
      label,
      color,
      noCalendar,
      meta: { touched, error, warning, active },
    } = this.props
    const { inputId, viewDate } = this.state

    const inactive = false
    const outerClasses = cn(
      display === 'box' ? sInput.outerBoxed : sInput.outer,
      { [sInput.invalid]: touched && error },
      { [sInput.white]: color === 'white' },
      { [sInput.inactive]: inactive }
    )

    const [date, month, year] = (input.value && input.value.split && input.value.split('/')) || ''
    const value = date && month && year ? new Date(year, month - 1, date) : ''

    if (noCalendar) {
      return (
        <div className={outerClasses}>
          <label htmlFor={inputId}>{label}</label>
          <input
            autoComplete="off"
            placeholder={'dd/mm/yyyy'}
            className={sInput.standard}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            value={input.value}
          />
          {display !== 'box' && <InputMessage error={error} warning={warning} touched={touched} />}
        </div>
      )
    }
    return (
      <Popover open={active} trigger="none" preferPlace="below">
        <div className={outerClasses}>
          <label htmlFor={inputId}>{label}</label>
          <input
            autoComplete="off"
            placeholder={'dd/mm/yyyy'}
            className={sInput.standard}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            value={input.value}
          />
          <a className={sInput.arrow} onClick={this.onFocus}>
            <IconChevronDown />
          </a>
          {display !== 'box' && <InputMessage error={error} warning={warning} touched={touched} />}
        </div>
        <div className={s.popup}>
          <Calendar
            onNextMonth={this.onNextMonth}
            onPrevMonth={this.onPrevMonth}
            selectedDate={value}
            viewDate={viewDate}
            onPickDate={this.onPickDate}
            type="datepicker"
          />
        </div>
      </Popover>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/DatePicker/DatePicker.jsx